import React, { Fragment, useState, useRef } from "react";
import Alert from "../layout/Alert";
import CircularProgress from "@mui/material/CircularProgress";
import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';

const formControlSx = (theme) => ({
    width: "100%",
    maxWidth: "100%",
    [theme.breakpoints.up("md")]: { maxWidth: 280 },
});

const UploadPSNDealerMapping = ({
    setAlert,
    deviceDealer: { uploadPSNDealerFileInProgress,
        uploadPSNDealerFileSuccess,
        uploadPSNDealerFileFailure },
    uploadPSNDealerFile
}) => {

    const theme = useTheme();
    const [uploadedPSNDealerFile, setUploadedPSNDealerFile] = useState("")
    const uploadedPSNDealerFileRef = useRef()

    function handleUploadPSNDealerFileMapping() {
        if (!uploadedPSNDealerFile || uploadedPSNDealerFile==="" || !uploadedPSNDealerFile.name.endsWith('.csv')) {
            setAlert('Invalid File', 'danger')
            return
        }

        let formData = new FormData()
        formData.append('csv_file', uploadedPSNDealerFile)

        uploadPSNDealerFile(formData)
    }

    function handleUploadPSNDealerFileReset() {
        setUploadedPSNDealerFile("")

        uploadedPSNDealerFileRef.current.value = ""
    }

    return (
        <Fragment>
            <div className="content-block bottom-shadow">
                <Alert />
                <div className="py-15" style={{ marginTop: "10px" }}>
                    <div style={{ display: "flex", alignItems: "center", flexWrap: "wrap", gap: 8, marginBottom: "20px" }}>
                        <label className="title" style={{ margin: 0, whiteSpace: "nowrap" }}>Upload CSV File: </label>
                        <Box sx={formControlSx(theme)} style={{ minWidth: 0, flex: "1 1 200px" }}>
                                <input
                                    className="md border-1"
                                    placeholder="Upload CSV File"
                                    accept=".csv"
                                    type="file"
                                    style={{ width: "100%", boxSizing: "border-box" }}
                                    name={uploadedPSNDealerFile?.name ?? uploadedPSNDealerFile}
                                    onChange={(e) => {
                                        setUploadedPSNDealerFile(e.target.files[0])
                                    }}
                                    ref={uploadedPSNDealerFileRef}
                                />
                        </Box>
                    </div>
                    <div className="row">
                        <button
                            className="btn btn-style-2 orange-bg"
                            onClick={handleUploadPSNDealerFileMapping}
                            disabled={uploadPSNDealerFileInProgress ? true : false}
                            style={{ marginLeft: "10px" }}
                        >
                            {
                                uploadPSNDealerFileInProgress ? <Fragment>
                                    <CircularProgress size="2em" style={{ color: "#AFB42B", marginTop: "5px" }} />
                                </Fragment>
                                    : "Upload"
                            }
                        </button>
                        <button
                            className="btn btn-style-2 dark-text gray-bg"
                            onClick={handleUploadPSNDealerFileReset}
                            style={{ marginLeft: "20px" }}
                            disabled={uploadPSNDealerFileInProgress ? true : false}
                        >
                            Reset
                        </button>
                    </div>
                </div>
            </div>
        </Fragment>
    );
}

export default UploadPSNDealerMapping